import React, { useEffect, useRef } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { FormatBold, FormatItalic, FormatListBulleted } from "@mui/icons-material";

export default function RichTextEditor({ value, onChange, placeholder }) {
  const editorRef = useRef(null);

  const execCmd = (command) => {
    document.execCommand(command, false, null);
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
      editorRef.current.focus();
    }
  };

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || "";
    }
  }, [value]);

  return (
    <Box sx={{ width: "100%", border: "1px solid #c4c4c4", borderRadius: 1, display: "flex", flexDirection: "column" }}>
      <Box sx={{ borderBottom: "1px solid #eee", p: 0.5, bgcolor: "#fafafa", display: "flex", gap: 0.5, flexWrap: "wrap" }}>
        <Tooltip title="Bold">
          <IconButton size="small" onClick={() => execCmd("bold")}><FormatBold /></IconButton>
        </Tooltip>
        <Tooltip title="Italic">
          <IconButton size="small" onClick={() => execCmd("italic")}><FormatItalic /></IconButton>
        </Tooltip>
        <Tooltip title="Bullet List">
          <IconButton size="small" onClick={() => execCmd("insertUnorderedList")}><FormatListBulleted /></IconButton>
        </Tooltip>
      </Box>

      <Box
        ref={editorRef}
        contentEditable
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        sx={{
          minHeight: 220,
          p: 2,
          outline: "none",
          fontSize: "1rem",
          fontFamily: "inherit",
          "& ul": { pl: 2 },
          "&:empty:before": { content: `"${placeholder || ""}"`, color: "#999" },
          maxWidth: "100%",
          overflowWrap: "break-word",
        }}
      />
    </Box>
  );
}